import type { AdvancedSearchMapParams } from 'src/api/redux/advancedSearches';
import type { DiscoveryMapState } from 'src/redux/slices/discoveryMapSlice';
import { extractBoundsParams } from 'src/redux/slices/discoveryMapSlice';

interface BuildParams {
  advancedSearchId: number;
  zoom: number;
  currentTerritoryId?: number | null;
  mapBounds: DiscoveryMapState['mapBounds'];
  advancedSearchRadius?: DiscoveryMapState['advancedSearchRadius'];
  overrides?: Partial<AdvancedSearchMapParams>;
}

/**
 * Builds the base AdvancedSearchMapParams shared by MedMapMarkers and MedMapContent.
 * Pass `overrides` for additional params like `heatmap` and `metric`.
 */
const buildAdvancedSearchMapParams = ({
  advancedSearchId,
  zoom,
  currentTerritoryId,
  mapBounds,
  advancedSearchRadius,
  overrides,
}: BuildParams): AdvancedSearchMapParams => {
  const params: AdvancedSearchMapParams = {
    id: advancedSearchId,
    zoom: zoom ?? 6,
    ...overrides,
  };
  if (advancedSearchRadius) {
    params.center = advancedSearchRadius.center;
    params.radius_miles = advancedSearchRadius.radius_miles;
  } else {
    if (currentTerritoryId) {
      params.territory_id = currentTerritoryId;
    }
    const boundsParams = extractBoundsParams(mapBounds);
    if (boundsParams) {
      Object.assign(params, boundsParams);
    }
  }
  return params;
};

export default buildAdvancedSearchMapParams;
